import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_ChildBehaviorChecklist = ({
   itemsRef,
   showErrorFor,
}) => {

   return (
      <form id='ACTS_ChildBehaviorChecklist' className='file-pdf-document'>
         <div className='file-template'>

            <h3>
               CHILD BEHAVIOR CHECKLIST FOR AGES 6-18
            </h3>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>CHILD'S First</span>
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Middle</span>
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Last</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="text" id="txtChildFirst" name="txtChildFirst" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtChildMiddle" name="txtChildMiddle" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtChildLast" name="txtChildLast" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>CHILD'S FULL NAME</span>
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>CHILD'S GENDER</span>
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>CHILD'S AGE</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="text" id="txtChildFullName" name="txtChildFullName" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbGender_Yes" name="rbGender" className='add-only' value="Boy" /> Boy &nbsp;
                     <input type="radio" id="rbGender_No" name="rbGender" className='add-only' value="Girl" /> Girl
                  </td>
                  <td className='w-250'>
                     <input type="text" id="txtChildAge" name="txtChildAge" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>CHILD'S ETHNIC GROUP OR RACE</span>
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>TODAY'S DATE</span>
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>CHILD'S BIRTHDATE</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="text" id="txtChildEthnic" name="txtChildEthnic" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='date' id="txtTodayDate" name="txtTodayDate" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <input type='date' id="txtChildBirthDate" name="txtChildBirthDate" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>GRADE IN SCHOOL</span>
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>NOT ATTENDING SCHOOL</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="text" id="txtGradeSchool" name="txtGradeSchool" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <input type="text" id="txtAttendingSchool" name="txtAttendingSchool" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               Please fill out this form to reflect your
               view of the child's behavior even if other
               people might not agree. Feel free to
               print additional comments beside each
               item and in the space provided on page
               2. Be sure to answer all items.
            </p>
            <p className='w-750'>
               <b>PARENTS'USUAL TYPE OF WORK, even if not working now.</b> (Please be specific - for example, auto mechanic, high school teacher,
               homemaker, laborer, lathe operator, shoe salesman, army sergeant.)
            </p>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>PARENT 1 (or FATHER) TYPE OF WORK </span>
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>PARENT 2 (or MOTHER) TYPE OF WORK</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="text" id="txtFatherWork" name="txtFatherWork" className='add-only' />
                  </td>
                  <td className='w-375'>
                     <input type="text" id="txtMotherWork" name="txtMotherWork" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>THIS FORM FILLED OUT BY:</span> <span className='small'>(print your full name)</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="text" id="txtPrintFullName" name="txtPrintFullName" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Your gender:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="radio" id="rbGender1_Yes" name="rbGender1" className='add-only' value="Man" /> Man &nbsp;
                     <input type="radio" id="rbGender1_No" name="rbGender1" className='add-only' value="Woman" /> Woman
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="radio" id="rbGender1_Ys" name="rbGender1" className='add-only' value="2" /> Other (specify): &nbsp;
                     <input type="text" id="txtOther" name="txtOther" className='add-only w-250 custom-add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Your relation to the child:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbParent_Yes" name="rbParent" className='add-only' value="1" /> Biological Parent
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbParent_No" name="rbParent" className='add-only' value="0" /> Step Parent
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbParent_Ys" name="rbParent" className='add-only' value="2" /> Grandparent
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbParent_Ysr" name="rbParent" className='add-only' value="3" /> Adoptive Parent
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbParent_Nj" name="rbParent" className='add-only' value="4" /> Foster Parent
                  </td>
                  <td className='w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="radio" id="rbParent_Yi" name="rbParent" className='add-only' value="5" /> Other (specify): &nbsp;
                     <input type="text" id="txtOther1" name="txtOther1" className='add-only w-250 custom-add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>I. Please list the sports your child most likes to take part in. For example: swimming, baseball, skating, skate boarding, bike riding, fishing, etc.</span>
               <input type="checkbox" id="cbNone" name="cbNone" className='add-only' value="None" />None
            </p>
            <table>
               <tr>
                  <td className='w-20'>
                     a.
                  </td>
                  <td className='w-730'>
                     <input type="text" id="txtSports1" name="txtSports1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     b.
                  </td>
                  <td className='w-730'>
                     <input type="text" id="txtSports2" name="txtSports2" className='add-only' />


                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     c.
                  </td>
                  <td className='w-730'>
                     <input type="text" id="txtSports3" name="txtSports3" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Compared to others of the same age, about how much time does he/she spend in each?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     Less Than Average
                  </td>
                  <td className='w-150'>
                     Average
                  </td>
                  <td className='w-200'>
                     More Than Average
                  </td>
                  <td className='w-200'>
                     Don't Know
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage1_Yes" name="rbAverage1" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage1_No" name="rbAverage1" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage1_Ys" name="rbAverage1" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage1_Ye" name="rbAverage1" className='add-only' value="3" />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage2_Yes" name="rbAverage2" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage2_No" name="rbAverage2" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage2_Ys" name="rbAverage2" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage2_Ye" name="rbAverage2" className='add-only' value="3" />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage3_Yes" name="rbAverage3" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage3_No" name="rbAverage3" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage3_Ys" name="rbAverage3" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage3_Ye" name="rbAverage3" className='add-only' value="3" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Compared to others of the same age, how well does he/she do each one?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     Below Average
                  </td>
                  <td className='w-150'>
                     Average
                  </td>
                  <td className='w-200'>
                     Above Average
                  </td>
                  <td className='w-200'>
                     Don't Know
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage4_Yes" name="rbAverage4" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage4_No" name="rbAverage4" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage4_Ys" name="rbAverage4" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage4_Ye" name="rbAverage4" className='add-only' value="3" />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage5_Yes" name="rbAverage5" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage5_No" name="rbAverage5" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage5_Ys" name="rbAverage5" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage5_Ye" name="rbAverage5" className='add-only' value="3" />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage6_Yes" name="rbAverage6" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage6_No" name="rbAverage6" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage6_Ys" name="rbAverage6" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage6_Ye" name="rbAverage6" className='add-only' value="3" />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>II. Please list your child's favorite hobbies, activities, and games, other than sports. For example: video games, dolls, reading, piano, crafts, cars, computers, singing, etc. </span> <span className='small'>(Do not include listening to radio, TV, or other media.)</span>
               <input type="checkbox" id="cbNone1" name="cbNone1" className='add-only' value="None1" />None
            </p>
            <table>
               <tr>
                  <td className='w-20'>
                     a.
                  </td>
                  <td className='w-730'>
                     <input type="text" id="txtSports4" name="txtSports4" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     b.
                  </td>
                  <td className='w-730'>
                     <input type="text" id="txtSports5" name="txtSports5" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     c.
                  </td>
                  <td className='w-730'>
                     <input type="text" id="txtSports6" name="txtSports6" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Compared to others of the same age, about how much time does he/she spend in each?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     Less Than Average
                  </td>
                  <td className='w-150'>
                     Average
                  </td>
                  <td className='w-200'>
                     More Than Average
                  </td>
                  <td className='w-200'>
                     Don't Know
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage11_Yes" name="rbAverage11" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage11_No" name="rbAverage11" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage11_Ys" name="rbAverage11" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage11_Ye" name="rbAverage11" className='add-only' value="3" />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage21_Yes" name="rbAverage21" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage21_No" name="rbAverage21" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage21_Ys" name="rbAverage21" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage21_Ye" name="rbAverage21" className='add-only' value="3" />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage31_Yes" name="rbAverage31" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage31_No" name="rbAverage31" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage31_Ys" name="rbAverage31" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage31_Ye" name="rbAverage31" className='add-only' value="3" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Compared to others of the same age, how well does he/she do each one?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     Below Average
                  </td>
                  <td className='w-150'>
                     Average
                  </td>
                  <td className='w-200'>
                     Above Average
                  </td>
                  <td className='w-200'>
                     Don't Know
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage41_Yes" name="rbAverage41" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage41_No" name="rbAverage41" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage41_Ys" name="rbAverage41" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage41_Ye" name="rbAverage41" className='add-only' value="3" />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage51_Yes" name="rbAverage51" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage51_No" name="rbAverage51" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage51_Ys" name="rbAverage51" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage51_Ye" name="rbAverage51" className='add-only' value="3" />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage61_Yes" name="rbAverage61" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage61_No" name="rbAverage61" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage61_Ys" name="rbAverage61" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage61_Ye" name="rbAverage61" className='add-only' value="3" />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>III. Please list any organizations, clubs, teams, or groups your child belongs to.</span>
               <input type="checkbox" id="cbNone3" name="cbNone3" className='add-only' value="None3" />None
            </p>
            <table>
               <tr>
                  <td className='w-20'>
                     a.
                  </td>
                  <td className='w-730'>
                     <input type="text" id="txtSports41" name="txtSports41" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     b.
                  </td>
                  <td className='w-730'>
                     <input type="text" id="txtSports51" name="txtSports51" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     c.
                  </td>
                  <td className='w-730'>
                     <input type="text" id="txtSports61" name="txtSports61" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Compared to others of the same age, how active is he/she is each?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     Less Active
                  </td>
                  <td className='w-150'>
                     Average
                  </td>
                  <td className='w-200'>
                     More Active
                  </td>
                  <td className='w-200'>
                     Don't Know
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage12_Yes" name="rbAverage12" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage12_No" name="rbAverage12" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage12_Ys" name="rbAverage12" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage12_Ye" name="rbAverage12" className='add-only' value="3" />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage22_Yes" name="rbAverage22" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage22_No" name="rbAverage22" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage22_Ys" name="rbAverage22" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage22_Ye" name="rbAverage22" className='add-only' value="3" />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage32_Yes" name="rbAverage32" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage32_No" name="rbAverage32" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage32_Ys" name="rbAverage32" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage32_Ye" name="rbAverage32" className='add-only' value="3" />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>IV. Please list any jobs or chores your child has. For example: doing dishes, babysitting, making bed, working in store, etc.</span> <span className='small'>(Include both paid and unpaid jobs and chores.)</span>
               <input type="checkbox" id="cbNone4" name="cbNone4" className='add-only' value="None4" />None
            </p>
            <table>
               <tr>
                  <td className='w-20'>
                     a.
                  </td>
                  <td className='w-730'>
                     <input type="text" id="txtSports7" name="txtSports7" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     b.
                  </td>
                  <td className='w-730'>
                     <input type="text" id="txtSports8" name="txtSports8" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-20'>
                     c.
                  </td>
                  <td className='w-730'>
                     <input type="text" id="txtSports9" name="txtSports9" className='add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Compared to others of the same age, how well does he/she carry them out?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     Below Average
                  </td>
                  <td className='w-150'>
                     Average
                  </td>
                  <td className='w-200'>
                     Above Average
                  </td>
                  <td className='w-200'>
                     Don't Know
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage10_Yes" name="rbAverage10" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage10_No" name="rbAverage10" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage10_Ys" name="rbAverage10" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage10_Ye" name="rbAverage10" className='add-only' value="3" />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage20_Yes" name="rbAverage20" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage20_No" name="rbAverage20" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage20_Ys" name="rbAverage20" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage20_Ye" name="rbAverage20" className='add-only' value="3" />
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage30_Yes" name="rbAverage30" className='add-only' value="1" />
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAverage30_No" name="rbAverage30" className='add-only' value="0" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage30_Ys" name="rbAverage30" className='add-only' value="2" />
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAverage30_Ye" name="rbAverage30" className='add-only' value="3" />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Be sure you answered all items. Then see other side.</b>
            </p>
            <h3>
               UNAUTHORIZED COPYING IS ILLEGAL
            </h3>
            <p className='w-750'>
               Copyright 2001 T. Achenbach<br />ASEBA, University of Vermont<br />1 South Prospect St., Burlington, VT 05401-3456<br />www.ASEBA.org
            </p>
            <p className='w-750'>
               07-02-18 Edition - 201
            </p>
            <p className='w-750'>
               Please print. Be sure to answer all items.
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>V. 1. About how many close friends does your child have? </span><span className='small'>(Do not include brothers & sisters)</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbAbout_Yes" name="rbAbout" className='add-only' value="1" /> None
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAbout_No" name="rbAbout" className='add-only' value="0" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAbout_Ys" name="rbAbout" className='add-only' value="2" /> 2 or 3
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbAbout_Ye" name="rbAbout" className='add-only' value="3" /> 4 or more
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>2. About how many times a week does your child do things with any friends outside of regular school hours? </span><span className='small'>(Do not include brothers & sisters)</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbAbout1_Yes" name="rbAbout1" className='add-only' value="1" /> Less than 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbAbout1_No" name="rbAbout1" className='add-only' value="0" /> 1 or 2
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbAbout1_Ys" name="rbAbout1" className='add-only' value="2" /> 3 or more
                  </td>
               </tr>
            </table>
            <h4>
               VI. Compared to others of his/her age, how well does your child:
            </h4>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>a. Get along with his/her brothers & sisters?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="radio" id="rbAbout2_Yes" name="rbAbout2" className='add-only' value="1" /> Worse
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAbout2_No" name="rbAbout2" className='add-only' value="0" /> Average
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbAbout2_Ys" name="rbAbout2" className='add-only' value="2" /> Better
                  </td>
                  <td className='w-300'>
                     <input type="radio" id="rbAbout2_Yi" name="rbAbout2" className='add-only' value="3" /> Has no brothers or sisters
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>b. Get along with other kids?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbAbout3_Yes" name="rbAbout3" className='add-only' value="1" /> Worse
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbAbout3_No" name="rbAbout3" className='add-only' value="0" /> Average
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbAbout3_Ys" name="rbAbout3" className='add-only' value="2" /> Better
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>c. Behave with his/her parents?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbAbout4_Yes" name="rbAbout4" className='add-only' value="1" /> Worse
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbAbout4_No" name="rbAbout4" className='add-only' value="0" /> Average
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbAbout4_Ys" name="rbAbout4" className='add-only' value="2" /> Better
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>d. Play and work alone?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbAbout5_Yes" name="rbAbout5" className='add-only' value="1" /> Worse
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbAbout5_No" name="rbAbout5" className='add-only' value="0" /> Average
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbAbout5_Ys" name="rbAbout5" className='add-only' value="2" /> Better
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>VII. 1. Performance in academic subjects.</span>
               <input type="checkbox" id="cbPerformance" name="cbPerformance" className='add-only' value="Performance" /> Does not attend school because
               <textarea id="txtPerformance" name="txtPerformance" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               Check a box for each subject that child takes
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>a. Reading, English, or Language Arts</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="radio" id="rbEnglish1_Yes" name="rbEnglish1" className='add-only' value="1" /> Failing
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish1_No" name="rbEnglish1" className='add-only' value="0" /> Below Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish1_Ys" name="rbEnglish1" className='add-only' value="2" /> Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish1_Yo" name="rbEnglish1" className='add-only' value="3" /> Above Average
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>b. History or Social Studies</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="radio" id="rbEnglish2_Yes" name="rbEnglish2" className='add-only' value="1" /> Failing
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish2_No" name="rbEnglish2" className='add-only' value="0" /> Below Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish2_Ys" name="rbEnglish2" className='add-only' value="2" /> Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish2_Yo" name="rbEnglish2" className='add-only' value="3" /> Above Average
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>c. Arithmetic or Math</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="radio" id="rbEnglish3_Yes" name="rbEnglish3" className='add-only' value="1" /> Failing
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish3_No" name="rbEnglish3" className='add-only' value="0" /> Below Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish3_Ys" name="rbEnglish3" className='add-only' value="2" /> Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish3_Yo" name="rbEnglish3" className='add-only' value="3" /> Above Average
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>d. Science</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="radio" id="rbEnglish4_Yes" name="rbEnglish4" className='add-only' value="1" /> Failing
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish4_No" name="rbEnglish4" className='add-only' value="0" /> Below Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish4_Ys" name="rbEnglish4" className='add-only' value="2" /> Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish4_Yo" name="rbEnglish4" className='add-only' value="3" /> Above Average
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     e.<input type="text" id="txtScience1" name="txtScience1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="radio" id="rbEnglish5_Yes" name="rbEnglish5" className='add-only' value="1" /> Failing
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish5_No" name="rbEnglish5" className='add-only' value="0" /> Below Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish5_Ys" name="rbEnglish5" className='add-only' value="2" /> Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish5_Yo" name="rbEnglish5" className='add-only' value="3" /> Above Average
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     f.<input type="text" id="txtScience2" name="txtScience2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="radio" id="rbEnglish6_Yes" name="rbEnglish6" className='add-only' value="1" /> Failing
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish6_No" name="rbEnglish6" className='add-only' value="0" /> Below Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish6_Ys" name="rbEnglish6" className='add-only' value="2" /> Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish6_Yo" name="rbEnglish6" className='add-only' value="3" /> Above Average
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     g.<input type="text" id="txtScience3" name="txtScience3" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type="radio" id="rbEnglish7_Yes" name="rbEnglish7" className='add-only' value="1" /> Failing
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish7_No" name="rbEnglish7" className='add-only' value="0" /> Below Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish7_Ys" name="rbEnglish7" className='add-only' value="2" /> Average
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbEnglish7_Yo" name="rbEnglish7" className='add-only' value="3" /> Above Average
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               Other academic subjects-for example: computer courses, foreign language, business. Do not include gym, shop, driver's ed., or other nonacademic subjects.
            </p>
            <p className='w-750'>
               <span className='eleHeader'>2. Does your child receive special education or remedial services or attend a special class or special school?</span>
               <input type="radio" id="rbEnglish8_Yes" name="rbEnglish8" className='add-only' value="0" /> No &nbsp;<br />
               <input type="radio" id="rbEnglish8_No" name="rbEnglish8" className='add-only' value="1" /> Yes-kind of services, class, or school:
               <textarea id="txtDescribe211" name="txtDescribe211" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>3. Has your child repeated any grades?</span>
               <input type="radio" id="rbEnglish9_Yes" name="rbEnglish9" className='add-only' value="0" /> No &nbsp;<br />
               <input type="radio" id="rbEnglish9_No" name="rbEnglish9" className='add-only' value="1" /> Yes-grades and reasons:
               <textarea id="txtDescribe1" name="txtDescribe1" className='add-only '></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>4. Has your child had any academic or other problems in school?</span>
               <input type="radio" id="rbEnglish10_Yes" name="rbEnglish10" className='add-only' value="0" /> No &nbsp;<br />
               <input type="radio" id="rbEnglish10_No" name="rbEnglish10" className='add-only' value="1" /> Yes-please describe: <br />
               <textarea id="txtDescribe2" name="txtDescribe2" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>When did these problems start? </span>
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="text" id="txtDescribe3" name="txtDescribe3" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Have these problems ended?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="radio" id="rbEnglish11_Yes" name="rbEnglish11" className='add-only' value="0" /> No &nbsp;<br />
                     <input type="radio" id="rbEnglish11_No" name="rbEnglish11" className='add-only' value="1" /> Yes-When?
                     <input type="text" id="txtScience11" name="txtScience11" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>Does your child have any illness or disability </span><span className='small'>(either physical or mental)</span>
               <input type="radio" id="rbEnglish12_Yes" name="rbEnglish12" className='add-only' value="0" /> No &nbsp; <br />
               <input type="radio" id="rbEnglish12_No" name="rbEnglish12" className='add-only' value="1" /> Yes-please describe: <br />
               <textarea id="txtDescribe4" name="txtDescribe4" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>What concerns you most about your child?</span>
               <textarea id="txtDescribe5" name="txtDescribe5" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Please describe the best things about your child.</span>
               <textarea id="txtDescribe7" name="txtDescribe7" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               Below is a list of items that describe children and youths. For each item that describes your child now or within the past 6
               months, please circle the 2 if the item is very true or often true of your child. Circle the 1 if the item is somewhat or sometimes
               true of your child. If the item is not true of your child, circle the 0. Please answer all items as well as you can, even if some do not
               seem to apply to your child.
            </p>
            <table>
               <tr>
                  <td className='w-250'>
                     <b>0 = Not True (as far as you know)</b>
                  </td>
                  <td className='w-250'>
                     <b>1 = Somewhat or Sometimes True</b>
                  </td>
                  <td className='w-250'>
                     <b>2 = Very True or Often True</b>
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>1. Acts too young for his/her age</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs1_No" name="rbActs1" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs1_Yes" name="rbActs1" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs1_Ys" name="rbActs1" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>2. Drinks alcohol without parents' approval </span><span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs2_No" name="rbActs2" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs2_Yes" name="rbActs2" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs2_Ys" name="rbActs2" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtActs" name="txtActs" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>3. Argues a lot</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs3_No" name="rbActs3" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs3_Yes" name="rbActs3" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs3_Ys" name="rbActs3" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>4. Fails to finish things he/she starts</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs4_No" name="rbActs4" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs4_Yes" name="rbActs4" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs4_Ys" name="rbActs4" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>5. There is very little he/she enjoys</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs5_No" name="rbActs5" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs5_Yes" name="rbActs5" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs5_Ys" name="rbActs5" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>6. Bowel movements outside toilet</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs6_No" name="rbActs6" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs6_Yes" name="rbActs6" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs6_Ys" name="rbActs6" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>7. Bragging, boasting</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs7_No" name="rbActs7" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs7_Yes" name="rbActs7" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs7_Ys" name="rbActs7" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>8. Can't concentrate, can't pay attention for long</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs8_No" name="rbActs8" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs8_Yes" name="rbActs8" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs8_Ys" name="rbActs8" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>9. Can't get his/her mind off certain thoughts;
                        obsessions</span> <span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs9_No" name="rbActs9" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs9_Yes" name="rbActs9" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs9_Ys" name="rbActs9" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtActs2" name="txtActs2" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>10. Can't sit still, restless, or hyperactive</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs10_No" name="rbActs10" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs10_Yes" name="rbActs10" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs10_Ys" name="rbActs10" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>11. Clings to adults or too dependent</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs11_No" name="rbActs11" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs11_Yes" name="rbActs11" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs11_Ys" name="rbActs11" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>12. Complains of loneliness</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs12_No" name="rbActs12" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs12_Yes" name="rbActs12" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs12_Ys" name="rbActs12" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>13. Confused or seems to be in a fog</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs13_No" name="rbActs13" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs13_Yes" name="rbActs13" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs13_Ys" name="rbActs13" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>14. Cries a lot</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs14_No" name="rbActs14" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs14_Yes" name="rbActs14" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs14_Ys" name="rbActs14" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>15. Cruel to animals</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs15_No" name="rbActs15" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs15_Yes" name="rbActs15" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs15_Ys" name="rbActs15" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>16. Cruelty, bullying, or meanness to others</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs16_No" name="rbActs16" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs16_Yes" name="rbActs16" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs16_Ys" name="rbActs16" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>17. Daydreams or gets lost in his/her thoughts</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs17_No" name="rbActs17" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs17_Yes" name="rbActs17" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs17_Ys" name="rbActs17" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>18. Deliberately harms self or attempts suicide</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs18_No" name="rbActs18" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs18_Yes" name="rbActs18" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs18_Ys" name="rbActs18" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>19. Demands a lot of attention</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs19_No" name="rbActs19" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs19_Yes" name="rbActs19" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs19_Ys" name="rbActs19" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>20. Destroys his/her own things</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs20_No" name="rbActs20" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs20_Yes" name="rbActs20" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs20_Ys" name="rbActs20" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>21. Detroys things belonging to his/her family or others</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs21_No" name="rbActs21" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs21_Yes" name="rbActs21" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs21_Ys" name="rbActs21" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>22. Disobedient at home</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs22_No" name="rbActs22" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs22_Yes" name="rbActs22" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs22_Ys" name="rbActs22" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>23. Disobedient at school</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs23_No" name="rbActs23" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs23_Yes" name="rbActs23" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs23_Ys" name="rbActs23" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>24. Doesn't eat well</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs24_No" name="rbActs24" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs24_Yes" name="rbActs24" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs24_Ys" name="rbActs24" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>25. Doesn't along with other kids</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs25_No" name="rbActs25" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs25_Yes" name="rbActs25" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs25_Ys" name="rbActs25" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>26. Doesn't seem to feel guilty after misbehaving</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs26_No" name="rbActs26" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs26_Yes" name="rbActs26" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs26_Ys" name="rbActs26" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>27. Easily jealous</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs27_No" name="rbActs27" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs27_Yes" name="rbActs27" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs27_Ys" name="rbActs27" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>28. Breaks rules a thome, school, or elsewhere</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs28_No" name="rbActs28" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs28_Yes" name="rbActs28" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs28_Ys" name="rbActs28" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>29. Fears certain animals, situations, or places, other than school</span>
                     <span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs29_No" name="rbActs29" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs29_Yes" name="rbActs29" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs29_Ys" name="rbActs29" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtHealthHistoryActs" name="txtHealthHistoryActs" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>30. Fears going to school</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs30_No" name="rbActs30" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs30_Yes" name="rbActs30" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs30_Ys" name="rbActs30" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>31. Fears he/she might think or do something bad</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs31_No" name="rbActs31" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs31_Yes" name="rbActs31" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs31_Ys" name="rbActs31" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>32. Feels he/she has to be perfect</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs32_No" name="rbActs32" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs32_Yes" name="rbActs32" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs32_Ys" name="rbActs32" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>33. Feels or complains that no one loves him/her</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs33_No" name="rbActs33" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs33_Yes" name="rbActs33" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs33_Ys" name="rbActs33" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>34. Feels others are out to get him/her</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs34_No" name="rbActs34" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs34_Yes" name="rbActs34" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs34_Ys" name="rbActs34" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>35. Feels worthless or inferior</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs35_No" name="rbActs35" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs35_Yes" name="rbActs35" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs35_Ys" name="rbActs35" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>36. Gets hurt a lot, accident-prone</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs36_No" name="rbActs36" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs36_Yes" name="rbActs36" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs36_Ys" name="rbActs36" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>37. Gets in many fights</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs37_No" name="rbActs37" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs37_Yes" name="rbActs37" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs37_Ys" name="rbActs37" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>38. Gets teased a lot</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs38_No" name="rbActs38" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs38_Yes" name="rbActs38" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs38_Ys" name="rbActs38" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>39. Hangs around with others who get in trouble</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs39_No" name="rbActs39" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs39_Yes" name="rbActs39" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs39_Ys" name="rbActs39" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>40. Hears sound or voices that aren't there
                     </span>  <span className='small'> (describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs40_No" name="rbActs40" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs40_Yes" name="rbActs40" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs40_Ys" name="rbActs40" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtDescribe" name="txtDescribe" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>41. Impulsive or acts without thinking</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs41_No" name="rbActs41" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs41_Yes" name="rbActs41" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs41_Ys" name="rbActs41" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>42. Would rather be alone than with others</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs42_No" name="rbActs42" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs42_Yes" name="rbActs42" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs42_Ys" name="rbActs42" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>43. Lying or cheating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs43_No" name="rbActs43" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs43_Yes" name="rbActs43" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs43_Ys" name="rbActs43" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>44. Bites fingernails</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs44_No" name="rbActs44" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs44_Yes" name="rbActs44" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs44_Ys" name="rbActs44" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>45. Nervous, highstrung, or tense</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs45_No" name="rbActs45" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs45_Yes" name="rbActs45" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs45_Ys" name="rbActs45" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>46. Nervous movements or twitching </span><span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs46_No" name="rbActs46" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs46_Yes" name="rbActs46" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs46_Ys" name="rbActs46" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtNervous" name="txtNervous" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>47. Nightmares</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs47_No" name="rbActs47" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs47_Yes" name="rbActs47" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs47_Ys" name="rbActs47" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>48. Not liked by other kids</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs48_No" name="rbActs48" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs48_Yes" name="rbActs48" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs48_Ys" name="rbActs48" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>49. Constipated, doesn't move bowels</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs49_No" name="rbActs49" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs49_Yes" name="rbActs49" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs49_Ys" name="rbActs49" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>50. Too fearful or anxious</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs50_No" name="rbActs50" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs50_Yes" name="rbActs50" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs50_Ys" name="rbActs50" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>51. Feels dizzy or lightheaded</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs51_No" name="rbActs51" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs51_Yes" name="rbActs51" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs51_Ys" name="rbActs51" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>52. Feels too guilty</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs52_No" name="rbActs52" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs52_Yes" name="rbActs52" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs52_Ys" name="rbActs52" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>53. Overeating</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs53_No" name="rbActs53" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs53_Yes" name="rbActs53" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs53_Ys" name="rbActs53" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>54. Overtired without good reason</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs54_No" name="rbActs54" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs54_Yes" name="rbActs54" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs54_Ys" name="rbActs54" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>55. Overweight</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs55_No" name="rbActs55" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs55_Yes" name="rbActs55" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs55_Ys" name="rbActs55" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>56. Physical problems without know medical cause:</span>
               <textarea id="txtPhysicalProblems" name="txtPhysicalProblems" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>a. Aches or pains </span><span className='small'>(not stomach or headaches)</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActsa_No" name="rbActsa" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsa_Yes" name="rbActsa" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsa_Ys" name="rbActsa" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>b. Headaches</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActsb_No" name="rbActsb" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsb_Yes" name="rbActsb" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsb_Ys" name="rbActsb" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>c. Nausea, feels sick</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActsc_No" name="rbActsc" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsc_Yes" name="rbActsc" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsc_Ys" name="rbActsc" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>d. Problems with eyes (not if corrected by glasses) </span><span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActsd_No" name="rbActsd" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsd_Yes" name="rbActsd" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsd_Ys" name="rbActsd" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtNotesProblems" name="txtNotesProblems" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>e. Rashes or other skin problems</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActse_No" name="rbActse" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActse_Yes" name="rbActse" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActse_Ys" name="rbActse" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>f. Stomachaches</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActsf_No" name="rbActsf" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsf_Yes" name="rbActsf" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsf_Ys" name="rbActsf" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>g. Vomiting, throwing up</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActsg_No" name="rbActsg" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsg_Yes" name="rbActsg" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsg_Ys" name="rbActsg" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>h. Other </span> <span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActsh_No" name="rbActsh" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsh_Yes" name="rbActsh" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActsh_Ys" name="rbActsh" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtOtherDes" name="txtOtherDes" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>57. Physically attacks people</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs57_No" name="rbActs57" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs57_Yes" name="rbActs57" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs57_Ys" name="rbActs57" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>58. Picks nose, skin, or other parts of body
                     </span> <span className='small'> (describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs58_No" name="rbActs58" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs58_Yes" name="rbActs58" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs58_Ys" name="rbActs58" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtOtherDes2" name="txtOtherDes2" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>59. Plays with own sex parts in public</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs59_No" name="rbActs59" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs59_Yes" name="rbActs59" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs59_Ys" name="rbActs59" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>60. Plays with own sex parts too much</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs60_No" name="rbActs60" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs60_Yes" name="rbActs60" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs60_Ys" name="rbActs60" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>61. Poor school work</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs61_No" name="rbActs61" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs61_Yes" name="rbActs61" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs61_Ys" name="rbActs61" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>62. Poorly coordinated or clumsy</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs62_No" name="rbActs62" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs62_Yes" name="rbActs62" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs62_Ys" name="rbActs62" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>63. Prefers being with older kids</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs63_No" name="rbActs63" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs63_Yes" name="rbActs63" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs63_Ys" name="rbActs63" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>64. Prefers being with younger kids</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs64_No" name="rbActs64" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs64_Yes" name="rbActs64" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs64_Ys" name="rbActs64" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>65. Refuses to talk</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs65_No" name="rbActs65" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs65_Yes" name="rbActs65" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs65_Ys" name="rbActs65" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>66. Repeats certain acts over and over;
                        compulsions</span><span className='small'> (describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs66_No" name="rbActs66" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs66_Yes" name="rbActs66" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs66_Ys" name="rbActs66" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtCmpulsions" name="txtCmpulsions" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>67. Runs away from home</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs67_No" name="rbActs67" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs67_Yes" name="rbActs67" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs67_Ys" name="rbActs67" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>68. Screams a lot</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs68_No" name="rbActs68" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs68_Yes" name="rbActs68" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs68_Ys" name="rbActs68" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>69. Secretive, keeps things to self</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs69_No" name="rbActs69" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs69_Yes" name="rbActs69" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs69_Ys" name="rbActs69" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>70. Sees things that aren't there</span> <span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs70_No" name="rbActs70" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs70_Yes" name="rbActs70" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs70_Ys" name="rbActs70" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtNotesAct" name="txtNotesAct" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>71. Self-conscious or easily embarrassed</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs71_No" name="rbActs71" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs71_Yes" name="rbActs71" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs71_Ys" name="rbActs71" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>72. Sets fires</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs72_No" name="rbActs72" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs72_Yes" name="rbActs72" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs72_Ys" name="rbActs72" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>73. Sexual problems</span> <span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs73_No" name="rbActs73" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs73_Yes" name="rbActs73" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs73_Ys" name="rbActs73" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtNotesSexual" name="txtNotesSexual" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>74. Showing off or clowning</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs74_No" name="rbActs74" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs74_Yes" name="rbActs74" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs74_Ys" name="rbActs74" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>75. Too shy or timid.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs75_No" name="rbActs75" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs75_Yes" name="rbActs75" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs75_Ys" name="rbActs75" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>76. Sleeps less than most kids</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs76_No" name="rbActs76" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs76_Yes" name="rbActs76" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs76_Ys" name="rbActs76" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>77. Sleeps more than most kids during day
                        and/or night</span> <span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs77_No" name="rbActs77" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs77_Yes" name="rbActs77" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs77_Ys" name="rbActs77" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtNotesSleeps1" name="txtNotesSleeps1" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>78. Inattentive or easily distracted</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs78_No" name="rbActs78" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs78_Yes" name="rbActs78" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs78_Ys" name="rbActs78" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>79. Speech problem </span><span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs79_No" name="rbActs79" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs79_Yes" name="rbActs79" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs79_Ys" name="rbActs79" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtNotesSleeps" name="txtNotesSleeps" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>80. Stares blankly</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs80_No" name="rbActs80" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs80_Yes" name="rbActs80" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs80_Ys" name="rbActs80" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>81. Steals at home</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs81_No" name="rbActs81" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs81_Yes" name="rbActs81" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs81_Ys" name="rbActs81" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>82. Steals outside the home</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs82_No" name="rbActs82" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs82_Yes" name="rbActs82" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs82_Ys" name="rbActs82" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>83. Stores up too many things he/she doesn't need </span><span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs83_No" name="rbActs83" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs83_Yes" name="rbActs83" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs83_Ys" name="rbActs83" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtNotesStores" name="txtNotesStores" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>84. Strange behavior  </span><span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs84_No" name="rbActs84" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs84_Yes" name="rbActs84" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs84_Ys" name="rbActs84" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtNotesStoresStrange" name="txtNotesStoresStrange" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>85. Strange ideas</span><span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs85_No" name="rbActs85" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs85_Yes" name="rbActs85" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs85_Ys" name="rbActs85" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtNotesStoresStrange1" name="txtNotesStoresStrange1" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>86. Stubborn, sullen, or irritable</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs86_No" name="rbActs86" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs86_Yes" name="rbActs86" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs86_Ys" name="rbActs86" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>87. Sudden changes in mood or feelings</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs87_No" name="rbActs87" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs87_Yes" name="rbActs87" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs87_Ys" name="rbActs87" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>88. Sulks a lot</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs88_No" name="rbActs88" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs88_Yes" name="rbActs88" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs88_Ys" name="rbActs88" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>89. Suspicious</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs89_No" name="rbActs89" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs89_Yes" name="rbActs89" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs89_Ys" name="rbActs89" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>90. Swearing or obscene language</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs90_No" name="rbActs90" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs90_Yes" name="rbActs90" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs90_Ys" name="rbActs90" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>91. Talks about killing self</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs91_No" name="rbActs91" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs91_Yes" name="rbActs91" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs91_Ys" name="rbActs91" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>92. Talks or walks in sleep</span> <span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs92_No" name="rbActs92" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs92_Yes" name="rbActs92" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs92_Ys" name="rbActs92" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtNotesStoresStrangeTalks" name="txtNotesStoresStrangeTalks" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>93. Talks too much</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs93_No" name="rbActs93" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs93_Yes" name="rbActs93" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs93_Ys" name="rbActs93" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>94. Teases a lot</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs94_No" name="rbActs94" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs94_Yes" name="rbActs94" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs94_Ys" name="rbActs94" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>95. Temper tantrums or hot temper</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs95_No" name="rbActs95" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs95_Yes" name="rbActs95" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs95_Ys" name="rbActs95" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>96. Thinks about sex too much</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs96_No" name="rbActs96" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs96_Yes" name="rbActs96" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs96_Ys" name="rbActs96" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>97. Threatens people</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs97_No" name="rbActs97" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs97_Yes" name="rbActs97" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs97_Ys" name="rbActs97" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>98. Thumb-sucking</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs98_No" name="rbActs98" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs98_Yes" name="rbActs98" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs98_Ys" name="rbActs98" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>99. Smokes, chews, or sniffs tobacco</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs99_No" name="rbActs99" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs99_Yes" name="rbActs99" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs99_Ys" name="rbActs99" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>100. Trouble sleeping </span><span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs100_No" name="rbActs100" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs100_Yes" name="rbActs100" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs100_Ys" name="rbActs100" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtTrouble" name="txtTrouble" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>101. Truancy, skips school</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs101_No" name="rbActs101" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs101_Yes" name="rbActs101" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs101_Ys" name="rbActs101" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>102. Underactive, slow moving, or lacks energy</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs102_No" name="rbActs102" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs102_Yes" name="rbActs102" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs102_Ys" name="rbActs102" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>103. Unhappy, sad, or depressed</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs103_No" name="rbActs103" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs103_Yes" name="rbActs103" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs103_Ys" name="rbActs103" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>104. Unusually loud</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs104_No" name="rbActs104" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs104_Yes" name="rbActs104" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs104_Ys" name="rbActs104" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>105. Uses drugs for nonmedical purposes (don't include alcohol or tobacco) </span><span className='small'>(describe):</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs105_No" name="rbActs105" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs105_Yes" name="rbActs105" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs105_Ys" name="rbActs105" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <textarea id="txtNotesUses" name="txtNotesUses" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>106. Vandalism</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs106_No" name="rbActs106" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs106_Yes" name="rbActs106" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs106_Ys" name="rbActs106" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>107. Wets self during the day</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs107_No" name="rbActs107" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs107_Yes" name="rbActs107" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs107_Ys" name="rbActs107" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>108. Wets the bed</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs108_No" name="rbActs108" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs108_Yes" name="rbActs108" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs108_Ys" name="rbActs108" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>109. Whining</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs109_No" name="rbActs109" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs109_Yes" name="rbActs109" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs109_Ys" name="rbActs109" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>110. Wishes to be of opposite sex</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs110_No" name="rbActs110" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs110_Yes" name="rbActs110" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs110_Ys" name="rbActs110" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>111. Withdrawn, does't get involved with others</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs111_No" name="rbActs111" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs111_Yes" name="rbActs111" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs111_Ys" name="rbActs111" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>112. Worries</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs112_No" name="rbActs112" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs112_Yes" name="rbActs112" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs112_Ys" name="rbActs112" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className='eleHeader'>113. Please write in any problems your child has that were not listed above:</span>
               <textarea id="txtNotesPlease" name="txtNotesPlease" className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <input type="text" id="txtEffectiv1" name="txtEffectiv1" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs113_No" name="rbActs113" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs113_Yes" name="rbActs113" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs113_Ys" name="rbActs113" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="text" id="txtEffectiv2" name="txtEffectiv2" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs114_No" name="rbActs114" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs114_Yes" name="rbActs114" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs114_Ys" name="rbActs114" className='add-only' value="2" /> 2
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type="text" id="txtEffectiv3" name="txtEffectiv3" className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                     <input type="radio" id="rbActs115_No" name="rbActs115" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs115_Yes" name="rbActs115" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-250'>
                     <input type="radio" id="rbActs115_Ys" name="rbActs115" className='add-only' value="2" /> 2
                  </td>
               </tr>
            </table>



         </div>
      </form>

   )
}  
